if(!customElements.get('swatch-links')) {
  customElements.define('swatch-links', class SwatchLinks extends HTMLElement {
    constructor() {
      super();
    }
  });
}
if(!customElements.get('swatch-switcher')) {
  customElements.define('swatch-switcher', class SwatchSwitcher extends HTMLElement {
    constructor() {
      super();

      window.swatchSwitcher = window.swatchSwitcher || {};

      this.swappableSections = Array.from(document.querySelectorAll('#MainContent > .shopify-section')).map(section => ({
        'sectionId': section.id.replace('shopify-section-', ''),
        'selector': '#' + section.id
      }));
      
      window.swatchSwitcher.sectionsEnabled = window.swatchSwitcher.sectionsEnabled || (this.swappableSections.length > 5 ? false : true);
      
      this.swatchLinkTriggerSelector = '.product--link__product';
      this.swatchLinksContainerEl    = this.querySelector('.product--links');
      /* edit/config anything ABOVE, but don't touch below */
      this.allSwatchEls           = this.querySelectorAll(this.swatchLinkTriggerSelector);
      this.allVariantIds          = [...this.allSwatchEls].map(({dataset}) => dataset.variantId);
      this.allSectionParam        = window.swatchSwitcher.sectionsEnabled ? this.swappableSections.map(({sectionId}) => sectionId).join() : false;
      this.allVariantsAndSections = window.swatchSwitcher.allVariantsAndSections || [...this.allSwatchEls].map(({dataset, href}) => [parseInt(dataset.variantId), href]).reduce((accumulator, value) => {
        const fetchURL = new URL(value[1]);
        if(window.swatchSwitcher.sectionsEnabled) {
          fetchURL.searchParams.append('sections', this.allSectionParam);
        }
        return {
          ...accumulator,
          [value[0]]: {
            'variantId': value[0],
            'url': value[1],
            'fetchUrl': fetchURL.toString(),
            'sections': this.swappableSections
          }
        };
      }, {}); // https://bobbyhadz.com/blog/javascript-convert-array-values-to-object-keys#convert-an-arrays-values-to-object-keys

      if(!window.swatchSwitcher.sectionsLoaded || !window.swatchSwitcher.allVariantsAndSections) {
        document.addEventListener('DOMContentLoaded', () => {
          // this.swatchLinksContainerEl.classList.add('loading');
          this.fetchAllUrls(this.allVariantIds).then(sectionData => {
            window.swatchSwitcher.allVariantsAndSections = this.allVariantsAndSections;
            sectionData.forEach(sectionDataSingle => {
              for(let [variantId, sectionsContentArray] of Object.entries(sectionDataSingle)) {
                window.swatchSwitcher.allVariantsAndSections[variantId].sections = sectionsContentArray;
              }
            });
            window.swatchSwitcher.sectionsLoaded = true;
            // this.swatchLinksContainerEl.classList.remove('loading');
          });
        });
      }

      this.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', this.onSwatchClick.bind(this));
      });

    }

    // https://stackoverflow.com/a/50007021/1231001
    fetchAllUrls(variantIds) {
      return Promise.all(
        variantIds.map(variantId => fetch(this.allVariantsAndSections[variantId].fetchUrl)
          .then(response => window.swatchSwitcher.sectionsEnabled ? response.json() : response.text())
          .then(parsedResponse => {
            return { [variantId]: this.allVariantsAndSections[variantId].sections.map(section => ({
              ...section,
              contentHtml: window.swatchSwitcher.sectionsEnabled ? new DOMParser().parseFromString(parsedResponse[section.sectionId], 'text/html') : new DOMParser().parseFromString(parsedResponse, 'text/html')
            })) };
          })
          .catch(error => {
            console.error(`There's an error in your config somewhere (${error})`);
            return error;
          })
        )
      );
    }

    onSwatchClick(e) {
      if(window.swatchSwitcher.sectionsLoaded) {
        e.preventDefault();
        const productEl  = e.target.closest(this.swatchLinkTriggerSelector);
        const productUrl = productEl.href;
        const variantId  = parseInt(productEl.dataset.variantId);
        if(!productEl.classList.contains('active') && window.swatchSwitcher.allVariantsAndSections) {
          window.swatchSwitcher.allVariantsAndSections[variantId].sections.forEach(({sectionId, selector, contentHtml}) => {
            document.querySelector(selector).innerHTML = contentHtml.querySelector(selector).innerHTML;
            this.reInitSections(selector, sectionId);
          });
          if(history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
            history.replaceState({}, 'variant', productUrl);
          }
        }
      }
    }
    
    reInitSections(sectionSelector, sectionId) {
      const imgLoad = new imagesLoaded(document.querySelector(sectionSelector), function() {
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: {
            sectionId: sectionId
          }
        }));
        document.dispatchEvent(new CustomEvent('shopify:section:select', {
          bubbles: true,
          detail: {
            sectionId: sectionId
          }
        }));
      });

      // reinitialize product
      let $product = document.querySelector('[data-section-type="product"]');
      if (!$product || $product.classList.contains('product-ready')) return;
      theme.sections.register('product', theme.Product);
    }
  });
}
